import { Col, Row } from 'antd';
import { get } from 'lodash';

import { renderCheckmarkFromBoolean } from '../../../utils/tables';
import Button from '../../Button';
import CustomTable from '../../Table';

const PromptsTable = props => {
  const { t, dataSource, loading, onViewPromptClick, onDeletePromptClick, ...rest } = props;

  const COLUMNS = [
    {
      key: 'name',
      title: t('name'),
      dataIndex: 'name',
      render: name => name || '-',
    },
    {
      key: 'type',
      title: t('type'),
      dataIndex: 'type',
      render: type => t(type || '-'),
    },
    {
      key: 'model',
      title: t('model'),
      dataIndex: 'model',
      render: model => model || '-',
    },
    {
      key: 'isActive',
      title: t('active'),
      align: 'center',
      render: (_, prompt) => renderCheckmarkFromBoolean(!!get(prompt, 'isActive')),
    },
    {
      key: 'actions',
      title: t('actions'),
      render: (_, prompt) => (
        <Row gutter={[8, 8]}>
          <Col flex={1}>
            <Button block size="xs" onClick={() => onViewPromptClick(get(prompt, '_id'))}>
              {t('view')}
            </Button>
          </Col>
          <Col flex={1}>
            <Button
              block
              type="secondary"
              size="xs"
              onClick={() => onDeletePromptClick(get(prompt, '_id'))}
            >
              {t('Delete')}
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <CustomTable
      {...rest}
      rowKey={prompt => get(prompt, '_id')}
      scroll={{ x: 960 }}
      columns={COLUMNS}
      dataSource={dataSource}
      loading={loading}
      showSearchInput={false}
    />
  );
};

export default PromptsTable;
